<template>
  <div>
    <div>
        <p>
          <strong v-if="cancellationTitle">
            {{cancellationTitle}}
          </strong>
          <strong v-else>
            {{$t('vue.manufaktur.amag.branchDropdown.near')}}
          </strong>
      </p>
      <p v-if="branchIsSet" class="condensed">
        {{ selectedBranch['Name Adresse'] }}<br>
        {{ selectedBranch['Strasse'] }}<br>
        {{ selectedBranch['Zip Code'] }} {{ $t(`${selectedBranch['Ort']}`) }}
      </p>
    </div>

    <select
        v-model="selected"
        class="form-control"
    >
      <option disabled value="">-- {{$t('vue.manufaktur.amag.branchDropdown.collection')}} --</option>

      <option
          v-for="branch in branchOptions"
          v-bind:value="branch.id"
      >
        {{ $t(`${branch["Anzeigename Dropdown"]}`) }}
      </option>
    </select>

    <input type="hidden" :value="selectedBranchString" name="selected_pickup_branch">
  </div>
</template>

<script>
export default {
  name: "BranchDropdown",
  props: {
    cancellationTitle: {
      type: String,
      required: false
    },
    givenBranch: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      selected: null,
      options: window.amagLocations,
    }
  },

  watch: {
    "selected.id" (newVal, oldVal) {
      this.$emit ('branch-changed', this.selected)
    }
  },

  computed: {
    selectedBranchString(){
      if(this.selectedBranch == undefined) {
        return ""
      }
      return this.selectedBranch['Name Adresse'].trim() + "||"
          + this.selectedBranch['Anzeigename Dropdown'].trim() + "||"
          + this.selectedBranch['Strasse'].trim() + "||"
          + this.selectedBranch['Ort'] + "||"
          + this.selectedBranch['Zip Code']
    },
    branchOptions () {
      return this.options
    },
    selectedBranch () {
      let branch = _.find (this.options, o => {
        return o.id === this.selected
      })

      return branch
    },
    branchIsSet() {
      return typeof this.selectedBranch != "undefined"
    }
  },

  created() {
    let branchFromOptions = _.find(this.options, o => {
      let street = this.givenBranch.street + " " + this.givenBranch.house_number
      let postalCode = this.givenBranch.postal_code
      let given = street.trim() + " " + postalCode.trim()
      let search = o['Strasse'].trim() + " " + o['Zip Code']
      return given === search
    })

    if(typeof branchFromOptions !== "undefined") {
      this.selected = branchFromOptions['id']
    }
  }
}
</script>
